import { defineStore } from "pinia";
import { ref } from "vue";

type SettingsStore = {
  userSettings: UserSettings;
};

type UserSettings = {
  weekends: boolean;
  weeknumbers: boolean;
  statsuall: boolean;
  filterext: boolean;

  filter: SearchFilter;
  search: SearchOptions;

  signature: null | undefined | string;
  dayGridNDays: number;
  ezTimelineNDays: number;
};

type SearchFilter = {
  orgcode: string[];
  free: string | null | undefined;
};

type SearchOptions = {
  companyid: null | string;
  orgcode: string[];
  // status: string[];
  free: null | string | undefined;
  signature: null | string | undefined; // mobile filer
  state: string[]; // work order state
};

const initialState: SettingsStore = {
  userSettings: {
    weekends: true,
    weeknumbers: false,
    statsuall: false,
    filterext: false,
    filter: {
      orgcode: [],
      free: null,
    },
    search: {
      orgcode: [],
      companyid: null,
      state: [],
      free: null,
      signature: null,
    },
    signature: null,
    dayGridNDays: 7,
    ezTimelineNDays: 1,
  },
};

function loadState() {
  const state = localStorage.getItem("state-user-settings");
  if (state === null) {
    return null;
  }

  return JSON.parse(state) as SettingsStore;
}

export const useUserSettingsStore = defineStore("userSettings", {
  state: (): SettingsStore => loadState() ?? initialState,
  actions: {
    showWeekends(value: boolean) {
      this.userSettings.weekends = value;
    },
    showWeekNumbers(value: boolean) {
      this.userSettings.weeknumbers = value;
    },
    showAllStates(value: boolean) {
      this.userSettings.statsuall = value;
    },
    showFilterExt(value: boolean) {
      this.userSettings.filterext = value;
    },
    updateFilterOrgCode(value: string[]) {
      this.userSettings.filter.orgcode = value;
    },
    updateFilterFree(value: string | null | undefined) {
      this.userSettings.filter.free = value;
    },
    updateSearchCompany(value: string | null) {
      this.userSettings.search.companyid = value;
    },
    updateSearchOrgCode(value: string[]) {
      this.userSettings.search.orgcode = value;
    },
    updateSearchState(value: string[]) {
      this.userSettings.search.state = value;
    },
    updateSearchFree(value: string | null | undefined) {
      this.userSettings.search.free = value;
    },
    updateSearchUserCode(value: string | null | undefined) {
      this.userSettings.search.signature = value;
    },
    setEzTimelineNDays(value: number) {
      this.userSettings.ezTimelineNDays = value;
    },
    setDayGridNDays(value: number) {
      this.userSettings.dayGridNDays = value;
    },
    setSignature(value: string | null | undefined) {
      this.userSettings.signature = value;
    },
  },
});
